import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.freeze";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { citysList, typeList, tableData, getUserList, assignDutyUser, recordById, tlMaintenance, maintenanceDelete } from '@/api/complexManage/mainManage.js';
import { onenet } from '@/api/onenet.js';
import { mapGetters } from 'vuex';
import DictVertical from "../util/demo/dict-vertical.vue";
import mainRepair from "./mainRepair.vue"; // import { delete } from 'vue/types/umd';

export default {
  name: 'mainManage',
  components: {
    mainRepair: mainRepair
  },
  data: function data() {
    DictVertical;
    return {
      currentPage: 1,
      totals: 0,
      pageSize: 1,
      // 区域列表
      cityList: [],
      props: {
        label: 'title',
        value: "title"
      },
      //状态
      typeList: [],
      query: {
        city: '',
        projectName: '',
        number: '',
        deviceNumber: '',
        status: '',
        address: '',
        current: 1,
        size: 10
      },
      column: Object.freeze([{
        prop: 'projectName',
        label: '项目名称'
      }, {
        prop: 'address',
        label: '安装地址'
      }, {
        prop: 'number',
        label: '维保单编号'
      }, {
        prop: 'statusValue',
        label: '维修状态'
      }, {
        prop: 'dutyUserName',
        label: '负责人'
      }, {
        prop: 'createTime',
        label: '报修时间'
      }, {
        prop: 'maintenanceTime',
        label: '最新维保时间'
      }]),
      tableData: [],
      // 报修弹窗
      DialogVisible2: false,
      // 其余弹窗
      // OSS相关
      host: 'http://thingcom-dianliuji.oss-cn-hangzhou.aliyuncs.com',
      ossParams: {
        OSSAccessKeyId: '',
        policy: '',
        signature: '',
        expire: '',
        key: '',
        // key后面有用，先默认设空字符串
        success_action_status: '200' // 默认200

      },
      limit: 10,
      imageUrl: '',
      //
      formLabelWidth: '110px',
      DialogVisible: false,
      dialogType: '新增',
      dialogImageUrl: '',
      form: {
        id: '',
        dutyUserId: '',
        disposePic: ''
      },
      //维保处理
      rules: [],
      // 派单相关
      userList: [],
      userName: '',
      phone: '',
      //维保记录
      userReport: [],
      mainRecord: []
    };
  },
  computed: _objectSpread({}, mapGetters(['permission'])),
  created: function created() {
    this.getCity();
    this.getType();
    this.getPage();
  },
  mounted: function mounted() {},
  methods: {
    init: function init() {
      this.form = {
        disposePic: ''
      };
      this.getPage();
    },
    // 查询区域级联列表
    getCity: function getCity() {
      var _this = this;

      var obj = {
        parentCode: '33'
      };
      citysList().then(function (res) {
        if (res.data.code == 200) {
          _this.cityList = res.data.data;
        }
      });
    },
    // 查询类型列表
    getType: function getType() {
      var _this2 = this;

      var obj = {
        code: 'maintenance_status'
      };
      typeList(obj).then(function (res) {
        if (res.data.code == 200) {
          _this2.typeList = res.data.data[0].children;
        }
      });
    },
    // 查询表格
    getPage: function getPage() {
      var _this3 = this;

      if (this.query.city) {
        this.query.city = this.query.city[1];
      }

      tableData(this.query).then(function (res) {
        if (res.data.code == 200) {
          _this3.tableData = res.data.data.records;
          _this3.totals = res.data.data.total;
          _this3.pageSize = res.data.data.pages;
        }
      });
    },
    reset: function reset() {
      this.query = {
        city: '',
        projectName: '',
        number: '',
        deviceNumber: '',
        status: '',
        address: '',
        current: 1,
        size: 10
      };
      this.getPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.query.current = val;
      this.getPage();
    },
    // 操作相关
    // 报修
    repairHandle: function repairHandle() {
      this.dialogType = '报修';
      this.DialogVisible2 = true;
    },
    // 用户报修和维保记录信息
    getRecordById: function getRecordById(row) {
      var _this4 = this;

      recordById({
        id: row.id
      }).then(function (res) {
        if (res.data.code == 200) {
          _this4.userReport = res.data.data.maintenanceDevice;

          var _iterator = _createForOfIteratorHelper(_this4.userReport),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              item.projectName = row.projectName;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          _this4.mainRecord = res.data.data.maintenanceRecord;

          var _iterator2 = _createForOfIteratorHelper(_this4.mainRecord),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _item = _step2.value;
              _item.disposePic = _item.disposePic.split(';');
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      });
    },
    // 派单
    distriHandle: function distriHandle(row) {
      var _this5 = this;

      this.dialogType = '派单';
      this.form.id = row.id;
      getUserList().then(function (res) {
        if (res.data.code == 200) {
          _this5.userList = res.data.data;
        }
      });
      this.getRecordById(row);
      this.DialogVisible = true;
    },
    changeUser: function changeUser(val) {
      this.userName = val.name;
      this.phone = val.phone;
      this.form.dutyUserId = val.id;
    },
    // 维保记录
    recordHandle: function recordHandle(row) {
      this.dialogType = '维保单处理记录';
      this.getRecordById(row);
      this.DialogVisible = true;
    },
    // 维保处理
    mainHandle: function mainHandle(row) {
      this.dialogType = '维保单处理';
      this.form.id = row.id;
      this.getRecordById(row);
      this.DialogVisible = true;
    },
    // 删除
    deleteHandle: function deleteHandle(scope) {
      var _this6 = this;

      this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        maintenanceDelete({
          id: scope.id
        }).then(function (res) {
          if (res.data.code == 200) {
            _this6.$message.success(res.data.msg);

            _this6.getPage();
          }
        });
      });
    },
    // 弹窗相关
    // 删除图片
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this7 = this;

      var obj = {};

      if (this.dialogType == '派单') {
        var _this$form = this.form,
            id = _this$form.id,
            dutyUserId = _this$form.dutyUserId;
        obj = {
          id: id,
          dutyUserId: dutyUserId
        };
        assignDutyUser(obj).then(function (res) {
          if (res.data.code == 200) {
            _this7.$message.success(res.data.msg);

            _this7.getPage();
          }
        });
      } else if (this.dialogType == '维保单处理') {
        var _this$form2 = this.form,
            _id = _this$form2.id,
            _dutyUserId = _this$form2.dutyUserId;
        var _this$form3 = this.form,
            maintenanceId = _this$form3.id,
            status = _this$form3.status,
            disposePic = _this$form3.disposePic,
            remark = _this$form3.remark;
        obj = {
          status: status,
          disposePic: disposePic,
          remark: remark,
          maintenanceId: maintenanceId
        };
        tlMaintenance(obj).then(function (res) {
          if (res.data.code == 200) {
            _this7.$message.success(res.data.msg);

            _this7.getPage();
          }
        });
      }

      this.close();
    },
    // 获取oss签名数据
    backOssInfo: function backOssInfo(file) {
      var fileName = file.name.substring(file.name.lastIndexOf('.') + 1);
      return new Promise(function (resolve, reject) {
        onenet.ossInfo().then(function (response) {
          if (response === undefined) {
            this.$message.error(response.error);
            reject();
          } else {
            this.ossParams.OSSAccessKeyId = response.accessid;
            this.ossParams.policy = response.policy;
            this.ossParams.signature = response.signature;
            this.ossParams.key = sessionStorage.getItem('userId') + this.randomWord(true, 9, 12) + '.' + fileName;
            resolve();
          }
        }.bind(this));
      }.bind(this));
    },
    randomWord: function randomWord(randomFlag, min, max) {
      var str = '';
      var range = min;
      var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']; // 随机产生

      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }

      for (var i = 0; i < range; i++) {
        var pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }

      return str;
    },
    exceed: function exceed(files, fileList) {
      this.$message.error('最多只能上传一个头像！');
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      // this.imageUrl = this.host + '/' + this.ossParams.key
      if (this.form.disposePic.length == 0) {
        this.form.disposePic = "".concat(this.host, "/").concat(this.ossParams.key);
      } else {
        this.form.disposePic += ";".concat(this.host, "/").concat(this.ossParams.key);
      }
    },
    beforeUpload: function () {
      var _beforeUpload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var isJPG, isLt1M;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.backOssInfo(file);

              case 2:
                isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                isLt1M = file.size / 1024 / 1024 < 1;

                if (!isJPG) {
                  this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }

                if (!isLt1M) {
                  this.$message.error('上传头像图片大小不能超过 1MB!');
                }

                return _context.abrupt("return", isJPG && isLt1M);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function beforeUpload(_x) {
        return _beforeUpload.apply(this, arguments);
      }

      return beforeUpload;
    }(),
    close: function close() {
      this.init();
      this.DialogVisible = false;
    },
    // 报修弹窗
    close2: function close2() {
      this.init();
      this.DialogVisible2 = false;
    }
  }
};